import { Line } from 'react-chartjs-2';
import { Box, Card, CardContent, Divider, useTheme } from '@mui/material';
import moment from 'moment';

export const GraficoTemperaturaOlio= (props) => {
  const theme = useTheme();

  const data = {
    datasets: [
      {
        backgroundColor: '#d32f2f',
        data: props?.datasetTempOlio?.map((item)=>item.data),
        label: 'Temperatura del fluido idraulico',
        maxBarThickness: 10
      },
      {
        label: "Temperatura liquido raffreddamento",
        data:  props?.datasetTempOlio?.map((item)=>item.data),
        backgroundColor: "#546e7a",
        maxBarThickness: 10
      }
    ],
    labels: props?.datasetTempOlio?.map((item)=>moment(item.timeStamp).format('DD/MM/YY hh:mm')),
  };

  const options = {
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      y: {
        beginAtZero: true           
      }
    },
    xAxes: [
      {
        ticks: {
          fontColor: theme.palette.text.secondary
        },
        gridLines: {
          display: false,
          drawBorder: false
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          fontColor: theme.palette.text.secondary,
          beginAtZero: true,
          min: 0
        },
        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: theme.palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: theme.palette.divider
        }
      }
    ],
    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary
    }
  };

  return (
    <Card {...props}>
      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 400,
            position: 'relative'
          }}
        >
          <Line
            data={data}
            options={options}
          />
        </Box>
      </CardContent>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          p: 2
        }}
      >
      </Box>
    </Card>
  );
};
